import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MarketingHeader from "@/components/marketing/Header";
import MarketingFooter from "@/components/marketing/Footer";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ArrowRight, PhoneCall } from "lucide-react";

const BANNER_IMG = "https://images.pexels.com/photos/8866772/pexels-photo-8866772.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function Services() {
  const [content, setContent] = useState(null);
  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data)).catch(() => {});
  }, []);
  const s = content?.services || {};
  const items = s.items || [];

  return (
    <div className="min-h-screen bg-white">
      <MarketingHeader />

      <section className="relative bg-[#0a2540] text-white overflow-hidden">
        <img src={BANNER_IMG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />
        <div className="relative max-w-7xl mx-auto px-6 py-24">
          <h1 className="font-display text-4xl sm:text-5xl font-light">{s.intro_title || "Our Services"}</h1>
          <p className="mt-4 text-white/70 max-w-2xl leading-relaxed">{s.intro_body}</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid md:grid-cols-3 gap-6" data-testid="services-list">
          {items.map((item) => (
            <div key={item.title} className="border border-slate-200 rounded-2xl p-8 bg-white hover:shadow-lg transition-shadow">
              <div className="h-12 w-12 rounded-xl bg-teal-50 flex items-center justify-center text-teal-600">
                <PhoneCall className="h-6 w-6" />
              </div>
              <h3 className="mt-5 font-display text-xl font-medium text-[#0a2540]">{item.title}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-20 bg-slate-50 border border-slate-200 rounded-2xl p-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div>
            <h2 className="font-display text-2xl font-medium text-[#0a2540]">Volume pricing available</h2>
            <p className="text-slate-600 mt-2 max-w-lg">Every call is metered to the second. Tell us about your languages and call volume and we'll put together a plan.</p>
          </div>
          <Link to="/contact">
            <Button size="lg" data-testid="services-quote-btn"
              className="rounded-full bg-yellow-400 text-[#0a2540] hover:bg-yellow-300 font-semibold h-12 px-7">
              Get a Quote <ArrowRight className="h-4 w-4 ml-1" />
            </Button>
          </Link>
        </div>
      </section>

      <MarketingFooter />
    </div>
  );
}
